<style> 
.btn-cancel 
{
    background-color: #fd913c;
    border-color: #fd913c;
    color: #fff;
}
</style>

<div class="container-fluid" style="background-color: #fff;padding: 10px;" >
    <div class="invoiceWrapper">
        <div class="headerWrapper">
            <h4> Products </h4>
            <div class="buttonWrapper">
                <button class="btn btn-success btn-sm" mat-raised-button> <i class="fa fa-check" aria-hidden="true" (click)="confirm(selectedProductIndex)" ></i>Ok</button>

                <button class="btn btn-cancel btn-sm" (click)="close()">
                    <i class="fa fa-times" aria-hidden="true"></i>Cancel
                </button>
            </div>
        </div>
        <div class="customModal">
        </div>

        <table class="table table-hover table-bordered">
            <thead>
                <tr>
                    <th scope="col">Product ID</th>
                    <th scope="col">Code</th>
                    <th scope="col">Name</th>
                    <th scope="col">Qty.</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Discount</th>
                    <th scope="col">Amount</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let in of productlist | paginate: { id: 'listing_pagination', itemsPerPage: 10, currentPage: current_page, totalItems: total_count}; let i = index" (click)="selectRow(i)" [ngClass]="{'sel': i === selectedProductIndex }">
                    <th scope="row">{{in.id}}</th>
                    <td>{{in.code}}</td>
                    <td>{{in.name}}</td>
                    <td>{{in.quantity}}</td>
                    <td>{{in.rate}}</td>
                    <td>{{in.discount}}</td>
                    <td>{{in.amount}}</td>
                </tr>
            </tbody>
        </table>

        <div class="footerWrapper row">
            <div class="searchWrapper col-lg-6">
                <div class="input-group">
                    <select id="mySelect" data-show-content="true" class="col-lg-4 border ">
                        <option> Select.. </option>
                        <option> Search by Name</option>
                        <option> Search by Body Part</option>
                        <option> Search by Implant</option>
                    </select>

                    <div>
                        <span class="input-group-prepend">
                            <input type="text" placeholder="example" class="form-control">
                            <span class="input-group-text">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </span>
                            <span class="input-group-text">
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3"></div>
            <div class="paginationWrapper">
                <pagination-controls id="listing_pagination" (pageChange)=getProductsData($event)></pagination-controls>
            </div>
        </div>
    </div>
</div>